import Heading from 'src/components/Heading/Heading';
import Routes from 'src/constants/Routes';
import classNames from 'classnames';
import { Accordion, Badge } from '@get-mosh/msh-shared';
import common from 'src/data/common.json';

export type FaqProps = {
    list: {
        question: string;
        answer: string;
    }[];
    className?: string;
    title?: string;
    subtitle?: string;
    backgroundColor?: string;
};

const Faq = (props: FaqProps) => {
    return (
        <div
            className={classNames(
                'container flex flex-col gap-2',
                props.className,
            )}
        >
            <div className="flex flex-col gap-4 text-center">
                <Heading
                    level="h2"
                    className={props.subtitle ? 'mb-2' : 'mb-4'}
                >
                    {props.title ? props.title : common.FAQ}
                </Heading>
                {props.subtitle && <p className="mb-4">{props.subtitle}</p>}
            </div>
            <div className="mx-auto mb-8 w-full md:w-[75%] lg:w-full lg:max-w-2xl">
                <Accordion
                    className="!border-0"
                    itemClassName={
                        props.backgroundColor
                            ? props.backgroundColor
                            : undefined
                    }
                    items={props.list.map((e) => ({
                        title: e.question,
                        content: e.answer,
                    }))}
                />
            </div>
            <div className="flex flex-col items-center gap-4">
                <p>Any other questions?</p>
                <Badge
                    as="a"
                    href={Routes.CONTACT_US}
                    variant="outline-dark"
                    text="Contact us"
                />
            </div>
        </div>
    );
};

export default Faq;
